import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const YourIQ = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Your IQ
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Your brain is more than just a number
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Imagine that somebody told you they could reduce everything that matters
                  about you — your creativity, your curiosity, your judgment, your imagination,
                  your persistence, your ability to solve problems, your potential for future
                  success — to a single number. Most of us would be sceptical.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  And yet, for more than a century, that's exactly what IQ has promised to do.
                  The idea is seductive. A simple score that tells us who is smart, who will
                  succeed, and perhaps even who we really are. Schools use it. Employers have
                  flirted with it. Entire careers have been built around it. But there's a
                  problem. Your brain doesn't work that way.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  A few years ago, my colleagues and I conducted what was the largest study of
                  intelligence and the brain ever undertaken. More than 44,000 volunteers
                  completed a battery of cognitive tests designed to probe memory, reasoning,
                  attention, planning, problem-solving, and a host of other mental abilities.
                </p>

              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end mt-4">
                <img
                  src="/your_iq.png"
                  alt="Your IQ"
                  className="w-full max-w-[700px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                We expected to find the elusive fingerprint of intelligence — the single
                factor that makes some people generally smarter than others. We didn't find
                it. But what we found instead was something far more interesting.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                People are cognitive mosaics. Even if you have an extraordinary memory, you
                may struggle with planning. A gifted problem-solver may be poor at focusing
                attention. Someone with average test scores may possess remarkable creativity,
                self-control, perseverance, or social insight.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                The brain is not a single engine producing intelligence. It is a collection
                of interacting systems, each contributing something different to the way we
                think. Which raises an intriguing question: what if we've spent the last
                hundred years measuring the wrong thing?
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why modern neuroscience
                has largely abandoned the search for an "IQ spot" in the brain, why executive
                function may tell us far more about success than intelligence ever could, and
                why qualities such as imagination, curiosity, self-control, and good judgment
                often matter far more than a number on a test.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                You'll discover that the most important question is not, how intelligent are
                you? But rather, how do you make best use of the intelligence you already
                have?
              </p>

              {/* Creyos Test Button */}
                <div className="mt-12 text-center">
                  <a
                    href="https://habstudy.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                  >
                    IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE,
                    CLICK HERE
                  </a>
                </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default YourIQ;